import React, { useState } from "react";

import { IssuesCloseOutlined } from "@ant-design/icons";
import { MaterialsTable } from "./components/MaterialsTable";
import { MaterialsSettings } from "./components/MaterialsSettings";
import { useDispatch, useSelector } from "react-redux";
import {
  changeWorkTypeTiedForMaterials,
  selectProject,
  setMaterialsForProject,
  updateProjectMaterialsThunk,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import MyBtnConfirm from "Components/MyBtnConfirm/MyBtnConfirm";
import { defaultSettings } from "css/defaultAntStyles";

export const MaterialsWrapper = ({ projectTitle, disabled }) => {
  const { projectMaterialsForTable, isMaterialsChanged } =
    useSelector(selectProject);
  const [openWorkTypeSetter, setOpenWorkTypeSetter] = useState(false);
  const dispatch = useDispatch();
  // const [projectMaterialsForTable] = useState([
  //   {
  //     id: 1,
  //     dateArrived: "2026-05-01",
  //     nomenclature: "Кабель ВВГнг 3×2.5",
  //     count: 500,
  //     restCount: 320,
  //     usedCount: 180,
  //     workTypeTied: {
  //       id: "",
  //       code: "",
  //       title: "",
  //     },

  //     "2026-05-01": {
  //       value: 20,
  //       comment:
  //         ")Початок монтажу кабельної лінії Початок монтажу кабельної лінії Початок монтажу кабельної лінії",
  //     },
  //     "2026-05-02": {
  //       value: 50,
  //       comment: "Видано бригаді №1",
  //     },
  //     "2026-05-03": {
  //       value: 110,
  //       comment: "Основний обсяг робіт по траншеї",
  //     },
  //   },

  //   {
  //     id: 2,
  //     dateArrived: "2026-05-02",
  //     nomenclature: "Труба ПВХ Ø25",
  //     count: 200,
  //     restCount: 150,
  //     usedCount: 50,
  //     workTypeTied: {
  //       id: "",
  //       code: "",
  //       title: "",
  //     },
  //     "2026-05-02": {
  //       value: 20,
  //       comment: "Монтаж у технічному приміщенні",
  //     },
  //     "2026-05-03": {
  //       value: 15,
  //       comment: "Прокладка по коридору",
  //     },
  //     "2026-05-04": {
  //       value: 15,
  //       comment: "Додаткове підключення",
  //     },
  //   },

  //   {
  //     id: 3,
  //     dateArrived: "2026-05-03",
  //     nomenclature: "Автоматичний вимикач 16А",
  //     count: 100,
  //     restCount: 65,
  //     usedCount: 35,
  //     workTypeTied: {
  //       id: "",
  //       code: "",
  //       title: "",
  //     },
  //     "2026-05-04": {
  //       value: 10,
  //       comment: "Щитова №1",
  //     },
  //     "2026-05-05": {
  //       value: 15,
  //       comment: "Щитова №2",
  //     },
  //     "2026-05-06": {
  //       value: 10,
  //       comment: "Резервне живлення",
  //     },
  //   },

  //   {
  //     id: 4,
  //     dateArrived: "2026-05-04",
  //     nomenclature: "Металевий лоток 100×50",
  //     count: 120,
  //     restCount: 90,
  //     usedCount: 30,
  //     workTypeTied: {
  //       id: "",
  //       code: "",
  //       title: "",
  //     },
  //     "2026-05-05": {
  //       value: 10,
  //       comment: "Монтаж на першому поверсі",
  //     },
  //     "2026-05-06": {
  //       value: 20,
  //       comment: "Монтаж на другому поверсі",
  //     },
  //   },

  //   {
  //     id: 5,
  //     dateArrived: "2026-05-05",
  //     nomenclature: "Щит розподільчий ЩР-24",
  //     count: 20,
  //     restCount: 12,
  //     usedCount: 8,
  //     workTypeTied: {
  //       id: "",
  //       code: "",
  //       title: "",
  //     },
  //     "2026-05-06": {
  //       value: 3,
  //       comment: "Корпус А",
  //     },
  //     "2026-05-07": {
  //       value: 5,
  //       comment: "Корпус Б",
  //     },
  //   },
  // ]);

  const setProjectMaterials = (data) => {
    if (data.length) {
      dispatch(setMaterialsForProject(data));
    }
  };
  const changeWorkTypeTied = (data) => {
    const { materialId, workTypeTied, materialNomenclature } = data;
    dispatch(
      changeWorkTypeTiedForMaterials({
        materialId,
        workTypeTied,
        materialNomenclature,
      }),
    );
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "right",
          margin: "0 0 10px 0",
        }}
      >
        <MaterialsSettings
          disabled={disabled}
          setProjectMaterials={setProjectMaterials}
          setOpenMaterialsWorkTypeSetter={setOpenWorkTypeSetter}
        />
        {isMaterialsChanged && !disabled && (
          <MyBtnConfirm
            disabled={disabled}
            textBtn="Зберегти зміни по матеріалам?"
            mainTitle="Зберегти зміни по матеріалам?"
            onConfirm={() => {
              dispatch(updateProjectMaterialsThunk());
            }}
            icon={
              <IssuesCloseOutlined
                style={{
                  color: defaultSettings.colorPrimary,
                  fontSize: "30px",
                }}
              />
            }
          />
        )}
      </div>
      <MaterialsTable
        changeWorkTypeTied={changeWorkTypeTied}
        openWorkTypeSetter={openWorkTypeSetter}
        disabled={disabled}
        projectTitle={projectTitle}
        projectMaterialsForTable={projectMaterialsForTable}
      />
    </>
  );
};
